import { ComponentType } from 'react';

import { ErrorPage403 } from './ErrorPage403';
import { ErrorPage404 } from './ErrorPage404';
import { ErrorPageGeneric } from './ErrorPageGeneric';

const pagesByCode: Record<number, ComponentType> = {
  403: ErrorPage403,
  404: ErrorPage404,
};

type Props = { errorStatus?: number };

export const ErrorPage = ({ errorStatus }: Props) => {
  if (errorStatus && errorStatus in pagesByCode) {
    const Page = pagesByCode[errorStatus];
    return <Page />;
  }
  return <ErrorPageGeneric />;
};
